import { render, staticRenderFns } from "./GRCActionPlansList.vue?vue&type=template&id=563f5a40&scoped=true&"
import script from "./GRCActionPlansList.vue?vue&type=script&lang=js&"
export * from "./GRCActionPlansList.vue?vue&type=script&lang=js&"
import style0 from "./GRCActionPlansList.vue?vue&type=style&index=0&id=563f5a40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563f5a40",
  null
  
)

export default component.exports